export default __webpack_public_path__ + "static/banner-easy-interior-design-ideas-a6783c4b79d8b76f79a60a20ee50ee24.jpg";